import React from "react";

const Settings = () => {
  return <div className="p-3 page-wrapper">Settings Page</div>;
};

export default Settings;
